'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactUtils = require('react-utils');

var _times = require('HubStyleTokens/times');

var _UILayer = require('../layer/UILayer');

var _UILayer2 = _interopRequireDefault(_UILayer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var SLIDEIN_MODAL_TRANSITION_TIMEOUT = parseInt(_times.SLIDEIN_MODAL_TRANSITION_TIMING, 10);

exports.default = _react2.default.createClass({
  displayName: 'UIStickyFooter',

  propTypes: {
    animateOnMount: _react.PropTypes.bool.isRequired,
    animateOnUnmount: _react.PropTypes.bool.isRequired,
    children: _react.PropTypes.node,
    className: _react.PropTypes.string
  },

  getDefaultProps: function getDefaultProps() {
    return {
      animateOnMount: true,
      animateOnUnmount: true
    };
  },
  render: function render() {
    var _props = this.props,
        animateOnMount = _props.animateOnMount,
        animateOnUnmount = _props.animateOnUnmount,
        children = _props.children,
        className = _props.className,
        rest = _objectWithoutProperties(_props, ['animateOnMount', 'animateOnUnmount', 'children', 'className']);

    return _react2.default.createElement(
      _UILayer2.default,
      {
        onUnmount: this.startClose,
        unmountDelay: SLIDEIN_MODAL_TRANSITION_TIMEOUT,
        transitionProps: {
          transitionName: 'slidein-from-bottom',
          transitionAppear: animateOnMount,
          transitionEnter: true,
          transitionLeave: animateOnUnmount,
          transitionAppearTimeout: SLIDEIN_MODAL_TRANSITION_TIMEOUT,
          transitionEnterTimeout: SLIDEIN_MODAL_TRANSITION_TIMEOUT,
          transitionLeaveTimeout: SLIDEIN_MODAL_TRANSITION_TIMEOUT
        }
      },
      _react2.default.createElement(
        'div',
        _extends({}, rest, {
          className: (0, _reactUtils.classNames)(className, 'private-sticky-footer')
        }),
        children
      )
    );
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1179/js/panel/UIStickyFooter.js
// module id = 353
// module chunks = 0